import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceLoop.css';
import LogoLoop from '../LogoLoop/LogoLoop';
import criminalDefenceIcon from '../../assets/servicesimages/icon_criminal_defence_gen.png';
import civilLawIcon from '../../assets/servicesimages/icon_civil_law_gen.png';
import propertyLawIcon from '../../assets/servicesimages/icon_property_law_gen.png';
import consumerLawIcon from '../../assets/servicesimages/icon_consumer_law_gen.png';
import bankingLawIcon from '../../assets/servicesimages/icon_banking_law_gen.png';
import insuranceLawIcon from '../../assets/servicesimages/icon_insurance_law_gen.png';
import arbitrationLawIcon from '../../assets/servicesimages/icon_arbitration_law_gen.png';
import chitFundIcon from '../../assets/servicesimages/icon_chit_fund_gen.png';
import drtIcon from '../../assets/servicesimages/icon_drt_gen.png';
import electricityLawIcon from '../../assets/servicesimages/icon_electricity_law_gen.png';

const ServicesLoop: React.FC = () => {


  const services = [
    {
      id: 'civil-law',
      image: civilLawIcon,
      title: 'Civil Law Service',
      description: 'Our service for civil law matters: your civil case will be processed with efficiency.',
    },
    {
      id: 'property-law',
      image: propertyLawIcon,
      title: 'Property Law Service',
      description: 'Protect your property rights with our professional advice.',
    },
    {
      id: 'criminal-law',
      image: criminalDefenceIcon, // Swapped icon to match title better if needed, but keeping original imports
      title: 'Criminal Law Service',
      description: 'Protect your rights and reputation with our seasoned criminal defense attorney.',
    },
    {
      id: 'banking-law',
      image: bankingLawIcon,
      title: 'Banking Law Service',
      description: 'Providing advice for bankers and clients on legal policies and anticipating risks.',
    },
    {
      id: 'consumer-law',
      image: consumerLawIcon,
      title: 'Consumer Law Service',
      description: 'Look after your consumer rights with our informed legal assistance.',
    },
    {
      id: 'insurance-law',
      image: insuranceLawIcon,
      title: 'Insurance Law Service',
      description: 'Get through insurance disputes and claims with legal assistance.',
    },
    {
      id: 'arbitration-law',
      image: arbitrationLawIcon,
      title: 'Arbitration Law Service',
      description: 'Resolve your disputes quickly with our expert arbitration lawyers.',
    },
    {
      id: 'chit-fund',
      image: chitFundIcon,
      title: 'Chit Fund Cases',
      description: 'Avail our best possible representation for chit fund matters.',
    },
    {
      id: 'debt-recovery-tribunal',
      image: drtIcon,
      title: 'Debt Recovery Tribunal',
      description: 'We will assist you in getting your money back with our expert DRT Legal Services.',
    },
    {
      id: 'electricity-law',
      image: electricityLawIcon,
      title: 'Electricity Law Service',
      description: 'Assistance with electricity disputes with our expert attorneys.',
    },
  ];



  const logos = services.map((service) => ({
    node: (
      <Link
        key={service.id}
        className="service-card"
        to={`/services/${service.id}`}
        style={{ cursor: 'pointer', textDecoration: 'none' }}
      >
        <div className="service-icon-box">
          <img src={service.image} alt={service.title} />
        </div>
        <div className="service-text">
          <h3 className="service-title">{service.title}</h3>
          <p className="service-description">{service.description}</p>
        </div>
      </Link>
    ),
  }));

  return (
    <section className="services-section">
      <LogoLoop
        logos={logos}
        speed={50}
        fadeOut
        className="services-loop"
        logoHeight={100} /* Reduced height constraint */
        gap={100} /* Increased gap to prevent overlap */
      />
    </section>
  );
};

export default ServicesLoop;
